import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup, Table,
  Progress,
  Collapse, Button, Fade,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Input,
  InputGroup,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Pagination,
  PaginationItem,
  PaginationLink
} from 'reactstrap';
import moment from 'moment';
import { Link } from "react-router-dom";
import { IMAGE } from "common-import/constants";
import { inject, observer } from "mobx-react"
import { VarHelper } from "common-import/helpers";
import { Loading } from "common-import/custom";

import Modal from 'react-responsive-modal';


@inject("userStore", "newsStore") @observer
class UserList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      isLoading: true,
      openYoutube: false,
      youtubeUrl: '',
    };

    this.search = this.search.bind(this);
  }

  async componentDidMount() {
    this.setState({isLoading: true});
    await this.props.userStore.onReady();
    await this.getList(this.state.page);
    this.setState({isLoading: false});
  }

  getList = async page => {
    const res = await this.props.newsStore.getTutorialsInternal();
    this.setState({})
    if (VarHelper.detectType(res) === 'array') {
      this.setState({ list: res });
    }
  };

  // loadPrev = e => {
  //   !!e && e.preventDefault();
  //   if(this.state.page === 1) return;
  //   const { userStore } = this.props;
  //   this.setState({ page: this.state.page === 1 ? 1 : this.state.page - 1}, () => {
  //     this.getList(this.state.page);
  //   });
  // };

  // loadNext = e => {
  //   !!e && e.preventDefault();
  //   const { userStore } = this.props;
  //   this.setState({ page: this.state.page + 1}, () => {
  //     this.getList(this.state.page);
  //   });
  // };

  search = (e) => {
    e.preventDefault();
  };

  showYoutubeModal = (url) => {
    console.log(url);
    this.setState({ youtubeUrl: url, openYoutube: true });
  }

  renderRow = (data, index) => {
    return (
      <tr key={"listuser" + index} className="cursor" onClick={() => this.showYoutubeModal(data['Youtube Url'])}>
        <td>
          <div>{data['Name Vietnamese']}</div>
        </td>
        <td>
          <span>{data['Category']}</span>
        </td>
        <td>
          <span>{data['Youtube Url']}</span>
        </td>
        <td>
          <div className="clearfix">
            <div className="float-left">
              <span className="small muted">{moment(data.createdAt).format('LL')}</span>
            </div>
          </div>
        </td>
      </tr>

    )
  };

  render() {
    if (this.state.isLoading) return (<Loading> </Loading>);
    const filterdList = (() => {
      const { keyword, list } = this.state;
      if (!keyword) return list;
      return list.filter(val => val['Name Vietnamese'].toLowerCase().includes(keyword.toLowerCase()));
    })();
    return (
      <div className="animated fadeIn">
        <div style={{ marginBottom: 20 }}>
          <span>Liên hệ admin nếu cần thêm hướng dẫn</span>
        </div>
        
        <Form onSubmit={this.search}>
          <FormGroup row>
            <Col md="12">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <Button onClick={this.search} type="button" color="primary"><i className="fa fa-search"> </i> Search</Button>
                </InputGroupAddon>
                <Input type="text" id="input1-group2 " name="input1-group2" value={this.state.keyword} onChange={e => this.setState({ keyword: e.target.value })} placeholder="Search video"/>
              </InputGroup>
            </Col>
          </FormGroup>
        </Form>
        <Row>
          <Col xs="12" sm="12">
            <Table hover responsive className="table-outline mb-0 d-sm-table">
              <thead className="thead-light">
                <tr>
                  {/* <th className="text-center"><i className="icon-people"> </i></th> */}
                  <th>Name</th>
                  <th>Category</th>
                  <th>Video</th>
                  {/* <th>Supper Admin</th> */}
                  <th>Created at</th>
                </tr>
              </thead>
              <tbody style={{ backgroundColor: 'white' }}>
                {filterdList.map((val, index) => this.renderRow(val, index))}
              </tbody>
            </Table>
          </Col>
        </Row>
        <Modal open={this.state.openYoutube} onClose={() => this.setState({ openYoutube: false, youtubeUrl: '' })}>
          {!!this.state.youtubeUrl &&
            <iframe src={VarHelper.toEmbedYoutube(this.state.youtubeUrl)} style={{ width: 600, height: 600 / 16 * 9, border: 'none' }} allowFullScreen />
          }
        </Modal>
        {/* <Row style={{ marginTop: 20, marginBottom: 20 }}>
          <Col xs="12" md="12">
            <Pagination>
              <PaginationItem>
                <PaginationLink previous onClick={this.loadPrev} />
              </PaginationItem>
              <PaginationItem>
                <PaginationLink>{this.state.page}</PaginationLink>
              </PaginationItem>
              <PaginationItem>
                <PaginationLink next onClick={this.loadNext} />
              </PaginationItem>
            </Pagination>
          </Col>
        </Row> */}
      </div>
    );
  }
}

export default UserList;



// WEBPACK FOOTER //
// ./src/views/Tutorials/Tutorials.js